module.exports = __webpack_public_path__ + "img/manyuser.26b95ec4.svg";